import { BAR, RADAR, LINE, HORIZONTAL_STACKED, VERTICAL_STACKED } from "src/components/Charts/types";
import { getAxisConfig } from "./axis";
import { getLabelConfig } from "./labels";
import { getSerieConfig } from "./series";
import { getLegend } from "./legends";
import { defaultEchartOption } from "./defaultEchartOption";

const defaultOptions = { ...defaultEchartOption };

const options = {
  default: (chartType, theme, checkedOptions) => ({
    ...defaultOptions,
    ...getAxisConfig(chartType, theme, checkedOptions),
    label: getLabelConfig(theme, checkedOptions),
    legend: getLegend(chartType, theme, checkedOptions.legend),
    series: getSerieConfig(chartType, checkedOptions.percentage, theme.title)
  }),
  [RADAR]: (theme, checkedOptions) => ({
    label: getLabelConfig(theme, checkedOptions),
    legend: getLegend(RADAR, theme, checkedOptions.legend),
    series: getSerieConfig(RADAR, checkedOptions.percentage, theme.title),
    angleAxis: {
      type: 'category',
      data: ['ALTERNATIVA', 'ALTERNATIVA'],
      axisLabel: {
        textStyle: {
          color: theme.colors.charts.axis.x.label,
        },
      },
      axisLine: {
        lineStyle: {
          color: theme.colors.charts.axis.x.line,
        },
      },
    },
    radiusAxis: {
      axisLine: {
        lineStyle: {
          color: theme.colors.charts.radar.radiusAxis.line,
        },
      },
      axisLabel: {
        textStyle: {
          color: theme.colors.charts.axis.x.label,
        },
      },
      splitLine: {
        lineStyle: {
          color: theme.colors.charts.radar.radiusAxis.splitLine,
        },
      },
    },
    polar: { radius: [0, '70%' ]},
    ...getAxisConfig(RADAR, theme, checkedOptions),
  }),
};

/**
 * Retorna true caso o gráfico exportado possua linhas grade (eixo x e eixo y), caso contrário, retorna false.
 * @param {string} chartType - Tipo de gráfico exportado {BAR | TYPEN}
 * @returns boolean
 */
export function isChartWithAllOptions(chartType) {
  return [BAR, LINE, HORIZONTAL_STACKED, VERTICAL_STACKED].includes(chartType);
}

/**
 * Retorna o echartOption correspondente com as configurações de cores aplicadas
 * @param {string} chartType - Tipo de gráfico exportado {BAR | TYPEN}
 * @param {object} theme - Objeto do tema atual da aplicação {LIGHT | DARK}
 * @param {object} checkedOptions - Objeto de opções de filtro definidas pelo usuário.
 * @returns {EchartOption<object>} Objeto de configuração do preview do gráfico exportado.
 */
export const getChartConfig = function(chartType, theme, checkedOptions) {
  const chartConfigGetter = options[chartType] || options.default.bind(null, chartType);
  return chartConfigGetter(theme, checkedOptions);
};